import { useTranslation } from 'next-i18next';

import { Box, Flex, Heading, Separator } from '@chakra-ui/react';

import { DepositInformation } from '@app/components/atoms/deposit-information';
import { PetsInformation } from '@app/components/atoms/pets-information';
import { OperatorInformation } from '@app/components/molecules/operator-information';
import * as accommodationStaticSlice from '@app/state/slices/accommodation-static.slice';
import { useAppSelector } from '@app/state/state';

import { ImportantInfoProps } from './important-info.props';
import { ImportantInfoItem } from './important-info-item';

export const ImportantInfo = ({ ...props }: ImportantInfoProps) => {
    const { t } = useTranslation('accommodation', {
        keyPrefix: 'importantInfo',
    });
    const { t: tStayRules } = useTranslation('accommodation', { keyPrefix: 'stayRules' });
    const { checkInStart, checkInEnd, checkOutStart, checkOutEnd } = useAppSelector(
        accommodationStaticSlice.selectors.selectImportantInfoData,
    );
    const { contactPhoneVisible } = useAppSelector(
        accommodationStaticSlice.selectors.selectContactPhoneData,
    );

    if (!(checkInStart || checkInEnd || checkOutStart || checkOutEnd)) return null;

    return (
        <Box {...props}>
            <Separator mb={6} />
            <Heading
                size={'md'}
                mb={{
                    base: 2,
                    md: 6,
                }}
            >
                {t('importantInfoHeader')}
            </Heading>
            <Flex direction={'column'} gap={4}>
                {contactPhoneVisible ? (
                    <ImportantInfoItem name={t('phoneNumber')} showPhoneNumber />
                ) : null}
                {checkInStart || checkInEnd ? (
                    <ImportantInfoItem
                        name={t('checkIn')}
                        fromHour={checkInStart}
                        toHour={checkInEnd}
                    />
                ) : null}
                {checkOutStart || checkOutEnd ? (
                    <ImportantInfoItem
                        name={t('checkOut')}
                        fromHour={checkOutEnd ? checkOutStart : null}
                        toHour={checkOutEnd || checkOutStart}
                    />
                ) : null}
                <ImportantInfoItem name={tStayRules('pets.label')}>
                    <PetsInformation />
                </ImportantInfoItem>
                <ImportantInfoItem name={tStayRules('deposit.label')}>
                    <DepositInformation />
                </ImportantInfoItem>
                <ImportantInfoItem name={t('legalInformation')}>
                    <OperatorInformation />
                </ImportantInfoItem>
            </Flex>
        </Box>
    );
};
